<!--Vista que muestra las afiliaciones que tiene actualmente un usuario de tipo afiliado-->
<template>
  <v-container fluid class="pa-0">
    <v-row justify="center" style="min-height:70vh">
      <v-col cols="12">
        <v-row justify="center">
          <!-- TÍTULO DE LA PÁGINA -->
          <v-col cols="10">
            <v-row justify="center">
              <v-col cols="12">
                <h1 class="display-2">Mis afiliaciones</h1>
                <v-divider class="mt-3"></v-divider>
              </v-col>
            </v-row>
          </v-col>

          <!-- SKELETON LOADER -->
          <v-col cols="10" v-if="loading">
            <v-row justify="center">
              <v-col cols="11" md="6" v-for="n in 4" :key="n">
                <v-sheet :color="`grey lighten-4`">
                  <v-skeleton-loader
                    class="pa-2 skeleton-card"
                    type="list-item-avatar-three-line"
                    :loading="loading"
                    transition="scale-transition"
                  ></v-skeleton-loader>
                </v-sheet>
              </v-col>
            </v-row>
          </v-col>

          <!-- EN CASO DE TENER EVENTOS -->
          <v-col v-else cols="12" md="10">
            <v-row justify="center" class="mb-5">
              <v-col cols="12">
                <product-list :items="affiliations" :affiliations="true" itemsPerPage=8></product-list>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <w-footer></w-footer>
  </v-container>
</template>
<script>
import productList from "@/components/assistant/products/productList";
import wFooter from "@/components/shared/w-footer";
import { mapActions, mapState } from "vuex";
export default {
  components: {
    productList,
    wFooter
  },
  data() {
    return {
      affiliations: [],
      loading: true
    };
  },
  computed: {
    ...mapState("affiliation", ["userAffiliations"])
  },
  methods: {
    ...mapActions("affiliation", ["fetchAffiliations"]),
    /**
     * Función para dar formato a los datos de las afiliaciones para poder mostrarlasen la vista con tarjetas por cada afiliación
     */
    async formatData() {
      await this.fetchAffiliations();
      this.affiliations = this.userAffiliations.map(userAffiliation => {
        return {
          id: userAffiliation.id,
          order: {
            id: userAffiliation.plan.id,
            createdAt: "2019-11-27",
            paymentInformation: {
              name: userAffiliation.affiliate.name,
              lastName: userAffiliation.affiliate.lastName,
              paymentType: userAffiliation.paymentInformation.paymentType
            }
          },
          organizer: {
            profilePicture: userAffiliation.plan.organizer.profilePicture
          },
          affiliation: { tier: { name: userAffiliation.tier.name } },
          name: userAffiliation.plan.name,
          expirationDate: userAffiliation.expirationDate,
          estatus: userAffiliation.estatus
        };
      });
    }
  },
  async mounted() {
    await this.formatData();
    this.affiliations = this.affiliations.filter(affiliation => {
      if (
        affiliation.order.paymentInformation.paymentType != "CARD" 
      )
        return affiliation;
      else if (affiliation.estatus!='IN_PROGRESS')
        return affiliation
    });
    this.loading = false;
  }
};
</script>
<style scoped>
.v-skeleton-loader >>> .v-skeleton-loader__list-item-three-line,  .v-skeleton-loader >>> .v-skeleton-loader__list-item-avatar-three-line{
  min-height: 150px;
}
</style>
